module.exports = __webpack_public_path__ + "static/media/AttendedCleans.3f0e7dfc.PNG";